import React, { useState, useRef, useEffect } from "react";
import { AiOutlineMenu, AiOutlineClose, AiOutlineSetting, AiOutlineSafety, AiOutlineDatabase, AiOutlineCheck, AiOutlineKey, AiOutlineBarChart, AiOutlineHistory } from "react-icons/ai";
import useUser from "../hooks/useUser";
import { useNotification } from "../hooks/useNotification";

const HamburgerMenu = ({ onAdminAction }) => {
  const { hasRole } = useUser();
  const notify = useNotification();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Cierra el menú si se hace clic fuera de él
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleAdminAction = (action) => {
    console.log(`Admin Action: ${action}`);
    setIsOpen(false); // Cerrar el menú después de la acción

    // Llamar a la función callback si existe
    if (onAdminAction) {
      onAdminAction(action);
    }

    // Mostrar notificación para acciones no implementadas
    if (action === 'preferences') {
      notify.info('Esta funcionalidad estará disponible próximamente');
    } else if (action === 'help') {
      notify.info('Esta funcionalidad estará disponible próximamente');
    }
  };

  return (
    <div style={styles.container} ref={menuRef}>
      <button
        onClick={toggleMenu}
        style={styles.hamburgerButton}
        title="Menú de aplicación"
      >
        <AiOutlineMenu size={20} />
      </button>

      {isOpen && (
        <div style={styles.dropdown}>
          <div style={styles.header}>
            <button
              onClick={() => setIsOpen(false)}
              style={styles.closeButton}
              title="Cerrar"
            >
              <AiOutlineClose size={16} />
            </button>
          </div>

          <div style={styles.content}>
            {/* Items de Administración - solo visible para ADMIN */}
            {hasRole('ADMIN') && (
              <>
                <div
                  style={styles.adminItem}
                  onClick={() => handleAdminAction('acls')}
                >
                  <AiOutlineSafety style={styles.itemIcon} />
                  <span>Gestión de ACLs</span>
                </div>
                <div
                  style={styles.adminItem}
                  onClick={() => handleAdminAction('specs')}
                >
                  <AiOutlineDatabase style={styles.itemIcon} />
                  <span>Series Documentales</span>
                </div>
                <div
                  style={styles.adminItem}
                  onClick={() => handleAdminAction('api-keys')}
                >
                  <AiOutlineKey style={styles.itemIcon} />
                  <span>Gestión de API Keys</span>
                </div>
                <div
                  style={styles.adminItem}
                  onClick={() => handleAdminAction('retention-policies')}
                >
                  <AiOutlineHistory style={styles.itemIcon} />
                  <span>Políticas de Retención</span>
                </div>
                <div
                  style={styles.adminItem}
                  onClick={() => handleAdminAction('index')}
                >
                  <AiOutlineDatabase style={styles.itemIcon} />
                  <span>Gestión de Índices</span>
                </div>
                <div style={styles.separator}></div>
              </>
            )}

            {/* Estadísticas de Series: para cualquier usuario autenticado, sin condición de rol.
                Enumerar roles dejaba afuera al Firmador (GitLab #33/#34) y contradecía a la pantalla
                de inicio, que siempre la ofreció sin condición. El dato que muestra —conteos por
                estado de cada serie— ya lo sirve el API a cualquier autenticado. */}
            <div
              style={styles.adminItem}
              onClick={() => handleAdminAction('stats')}
            >
              <AiOutlineBarChart style={styles.itemIcon} />
              <span>Estadísticas de Series</span>
            </div>
            <div style={styles.separator}></div>

            {/* Workflow de control de calidad (OCR / revisión / aprobación / firma / rechazados).
                La firma (#59 F1C) es un estado más del workflow → vive como tab acá, no aislado. */}
            {(hasRole('REVIEWER') || hasRole('APPROVER') || hasRole('SIGNER')) && (
              <>
                <div
                  style={styles.adminItem}
                  onClick={() => handleAdminAction('approval')}
                >
                  <AiOutlineCheck style={styles.itemIcon} />
                  <span>Control de calidad</span>
                </div>
                <div style={styles.separator}></div>
              </>
            )}

            {/* Sección de Configuración */}
            <div style={styles.section}>
              {/*<div style={styles.sectionHeader}>
                <span style={styles.sectionTitle}>Configuración</span>
              </div>*/}
              <div style={styles.submenu}>
                {/*<div 
                  style={styles.item}
                  onClick={() => handleAdminAction('preferences')}
                >
                  <span>Preferencias</span>
                </div>*/}
                <div
                  style={styles.item}
                  onClick={() => handleAdminAction('help')}
                >
                  <span>Ayuda</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    position: 'relative',
    display: 'inline-block',
  },
  hamburgerButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '4px',
    color: '#FFFFFF',
    transition: 'background-color 0.2s ease',
    width: '40px',
    height: '40px',
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    right: '0',
    marginTop: '8px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #D1D5DB',
    borderRadius: '6px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    minWidth: '250px',
    zIndex: 1000,
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '8px 12px',
    backgroundColor: '#F8F9FA',
    borderBottom: '1px solid #E5E7EB',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
    borderRadius: '4px',
    color: '#6B7280',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    padding: '8px 0',
  },
  separator: {
    height: '1px',
    backgroundColor: '#E5E7EB',
    margin: '8px 0',
  },
  adminItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    cursor: 'pointer',
    color: '#374151',
    fontSize: '14px',
    transition: 'background-color 0.2s ease',
    borderLeft: '3px solid transparent',
  },
  adminItemHover: {
    backgroundColor: '#F3F4F6',
    borderLeftColor: '#00468B',
  },
  itemIcon: {
    marginRight: '8px',
    fontSize: '14px',
    color: '#6B7280',
  },
  section: {
    marginBottom: '0',
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    color: '#00468B',
    fontSize: '14px',
    fontWeight: '500',
    backgroundColor: '#F8F9FA',
    borderBottom: '1px solid #E5E7EB',
  },
  sectionTitle: {
    flex: 1,
  },
  submenu: {
    backgroundColor: '#FFFFFF',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    cursor: 'pointer',
    color: '#374151',
    fontSize: '14px',
    transition: 'background-color 0.2s ease',
  },
  itemHover: {
    backgroundColor: '#F3F4F6',
  },
};

export default HamburgerMenu;
